module.exports = new __parcel__URL__("plane_3_blue.7d0ec18d.png").toString();